<div class="index-head">
    <span>{{ title || 'Plan Expired'}}</span>
</div>
<div class="padding-index">
    <span>{{ discription || 'Please activate your plan to continue using the services.'}}</span>
</div>

<div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'restriction-btn-1' + '__' + sanitizedUrl" (click)="upgrade()" mat-raised-button>{{button || ''}}</button>
</div>
